import React from "react";
import { TitleLink } from "../components/header/Header.style";

export const title = [
  `I am Mitra Mejía, love all web things \n`,
  <>
    Currently a Senior Software Engineer helping people build credit{" \n"}
    <TitleLink href="https://petalcard.com">@petal</TitleLink>
  </>,
];

export const urls = [
  { text: "LinkedIn", url: "https://www.linkedin.com/in/mitramej%C3%ADa/" },
  { text: "Github", url: "http://github.com/mitramejia" },
  { text: "Instagram ", url: "https://instagram.com/mitramejia" },
  { text: "Dribbble", url: "https://dribbble.com/mitramejia" },
  { text: "Twitter", url: "https://twitter.com/mitramejia" },
  { text: "Contact", url: "mailto:mitra@mitramejia.com" },
];
